module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ESTUDICAB — Cabinet de conseil en certification et formation","short_name":"ESTUDICAB","description":"Cabinet de conseil et ingénierie en certification et formation professionnelle.","start_url":"/","background_color":"#0f2540","theme_color":"#e05c2a","display":"minimal-ui","icon":"src/images/favicon3.png","lang":"fr","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3f4cc5140b7e9e96dfa56cbfda9e34ab"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
